module.exports = __webpack_public_path__ + "media/5.2f0576f7.wav";